import React, { Component } from 'react';
import { Element } from 'react-scroll';
import Footer from '../Footer';
import * as blocks from '../LandingBlockWrapper';
import messages from './messages';
/*
  '#tech-specs'
*/

export const pages = {
	'#home': {
		Component: blocks.Home,
		visible: false,
	},
	'#fresh-mint': {
		Component: blocks.FreshMint,
		visible: true,
		title: messages.freshMint
	},
	'#platform': {
		Component: blocks.Platform,
		visible: true,
		title: messages.platform
	},
	'#how-it-works': {
		Component: blocks.HowItWorks,
		visible: true,
		title: messages.howItWorks
	},
	'#features': {
		Component: blocks.Features,
		visible: true,
		title: messages.features
	},
	'#survey': {
		Component: blocks.Survey,
		visible: false,
	},
	'#tech-specs': {
		Component: blocks.TechSpecs,
		visible: true,
		title: messages.techSpecs
	},
	'#sale-and-rent': {
		Component: blocks.SaleAndRent,
		visible: true,
		title: messages.saleAndRent
	},
	'#cross-platform': {
		Component: blocks.CrossPlatform,
		visible: false,
	},
	'#gallery': {
		Component: blocks.Gallery,
		visible: false,
	},
	// '#tech-overview': {
	// 	Component: blocks.TechOverview,
	// 	visible: false,
	// },
};

/*
  ['#gallery']: {
    Component: blocks.Gallery,
    visible: false,
  },
*/

/*
const close = () => {
  console.log(
      'Notification was closed. Either the close button was clicked or duration time elapsed.');
};

const openNotification = () => {
  const key = `open${Date.now()}`;
  const btn = (
      <Button type="primary" size="small"
              onClick={() => notification.close(key)}>
        Pass Survey!
      </Button>
  );
  notification.open({
    message: 'Make contribution!',
    description: 'Pass interesting survey! Share your opinion.',
    btn,
    key,
    duration: 0,
    onClose: close,
  });
};
*/

class Home extends Component{
	
	render() {
		return (
			<div id="LandingPage" className='LandingPage'>
				{Object.keys(pages).map(p => {
					let { Component } = pages[p];
					return <Element key={p} id={p}><Component/></Element>;
				})}
				<Footer/>
			</div>
		);
	}
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Landing/Landing.js